import React from "react";
import styled from "styled-components";
import { parseHtml } from "pages/PanelPage/helpers/parseHtml";
import { FlexContainer } from "components/Atoms/Containers";
import { checkMarkIcon } from "components/Atoms/Icons/checkMarkIcon";
import { redXIcon } from "components/Atoms/Icons/redXIcon";
import { DivBody1 } from "components/Atoms/Text";

const SelectOptions = ({
  attempt: {
    question: { options, can_select_multiple },
    answer
  },
  formattedTimeTaken
}) => {
  const answerLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

  const renderQuestionOptions = () => {
    const selectedAnswersIds = answer?.options?.map(option => option.id);

    return options?.map(option => {
      return (
        <QuestionOption
          key={option.id}
          selected={selectedAnswersIds?.includes(option.id)}
        >
          <OptionSelect canSelectMultiple={can_select_multiple} />
          <DivBody1 margin="0 6px 0 0">
            {answerLetters[option.sort_index]}.
          </DivBody1>
          <DivBody1>
            {parseHtml(option.content[0].text_display, true)}{" "}
          </DivBody1>
        </QuestionOption>
      );
    });
  };

  const handleCorrectSelect = () => {
    let correctAnswer = options.reduce((currentHighValue, currentOption) => {
      return currentHighValue.value > currentOption.value
        ? currentHighValue
        : currentOption;
    });

    return (
      <CorrectContainer
        align="center"
        justify="space-between"
        background={
          correctAnswer.id === (answer?.options && answer?.options[0]?.id)
            ? "#e6f1de"
            : "#faddd6"
        }
      >
        <FlexContainer align="center">
          <DivBody1 color="#df7c48" margin="0 13px 0 0">
            {correctAnswer.id === (answer?.options && answer?.options[0]?.id)
              ? checkMarkIcon
              : redXIcon}
          </DivBody1>
          <DivBody1>
            Correct answer:{" "}
            <AnswerText>{answerLetters[correctAnswer.sort_index]}</AnswerText>
          </DivBody1>
        </FlexContainer>
        {formattedTimeTaken && (
          <DivBody1>
            Time spent: <AnswerText>{formattedTimeTaken}</AnswerText>
          </DivBody1>
        )}
      </CorrectContainer>
    );
  };

  const handleMultipleCorrectSelect = () => {
    const correctAnswers = options.filter(option => option.value > 0);
    const correctAnswersIds = correctAnswers.map(option => option.id);
    const correctAnswersLetters = correctAnswers.map(
      option => answerLetters[option.sort_index]
    );

    const selectedAnswersIds = answer?.options?.map(option => option.id) || [];
    const isCorrect =
      correctAnswersIds.length === selectedAnswersIds.length &&
      correctAnswersIds.every(id => selectedAnswersIds.includes(id));

    return (
      <CorrectContainer
        align="center"
        justify="space-between"
        background={isCorrect ? "#e6f1de" : "#faddd6"}
      >
        <FlexContainer align="center">
          <DivBody1 color="#df7c48" margin="0 13px 0 0">
            {isCorrect ? checkMarkIcon : redXIcon}
          </DivBody1>
          <DivBody1>
            Correct answer:{" "}
            <AnswerText>{correctAnswersLetters.join(", ")}</AnswerText>
          </DivBody1>
        </FlexContainer>
        {formattedTimeTaken && (
          <DivBody1>
            Time spent: <AnswerText>{formattedTimeTaken}</AnswerText>
          </DivBody1>
        )}
      </CorrectContainer>
    );
  };

  return (
    <div data-testid="select-options">
      {renderQuestionOptions()}
      {can_select_multiple
        ? handleMultipleCorrectSelect()
        : handleCorrectSelect()}
    </div>
  );
};

export default SelectOptions;

const AnswerText = styled.span`
  font-weight: bold;
`;

const CorrectContainer = styled(FlexContainer)`
  border-radius: 4px;
  height: 40px;
  margin: 20px 24px 20px 0;
  padding: 5px 28px 0 32px;
`;

const OptionSelect = styled.div`
  border: 1px solid #c9c9c9;
  border-radius: ${({ canSelectMultiple }) =>
    canSelectMultiple ? "4px" : "14px"};
  flex-shrink: 0;
  height: 16px;
  margin-right: 16px;
  width: 16px;
`;

const QuestionOption = styled(FlexContainer)`
  border: 1px solid #c9c9c9;
  border-radius: 4px;
  margin: 7px 0;
  padding: 12px 18px 8px 12px;
  width: 762px;
  ${({ selected, theme: { tenantAccent } }) => {
    return selected && `border: 1px solid ${tenantAccent};`;
  }}
  ${OptionSelect} {
    ${({ selected, theme: { tenantAccent } }) => {
      return (
        selected &&
        `border: 1px solid ${tenantAccent}; 
        background: ${tenantAccent};`
      );
    }}
  }
  img {
    max-width: 100%;
  }
`;
